import { Flex } from '@chakra-ui/react';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = ({ t }) => {
  return (
    <Flex className={styles['head__container']} justifyContent={'space-between'}>
      <TextBold className={styles['head__title']}>{t('title')}</TextBold>
    </Flex>
  );
};

export default Head;
